import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static noWhitespace(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string;
    return value && value.indexOf(' ') !== -1 ? { whitespace: true } : null;
  }
}
